<template>
  <top-navbar
    v-if="
      showLayout &&
        route.name !== 'NotFoundMag' &&
        route.name !== 'NotFoundMagGeneral'
    "
  />
  <main
    class="error-page-container"
    :class="route.name === 'NotFoundMag' ? 'background-mag' : ''"
  >
    <div class="message-container">
      <i
        ><img
          :src="require('@/assets/images/ic-error-notice.svg')"
          :alt="$t('wegow.error.altErrorIcon')"
      /></i>
      <p>{{ $t("wegow.error.pageNotFound") }}</p>
      <w-navigation
        :params="
          route.name !== 'NotFoundMag' && route.name !== 'NotFoundMagGeneral'
            ? { name: 'home' }
            : { name: 'MagazineMainPage' }
        "
        :full="false"
      >
        <template #link>
          <wegow-button
            id="go-to-wegow-button"
            background="opacity"
            color="topaz"
            type="button"
            :text="$t('general.routes.goHome')"
          />
        </template>
      </w-navigation>
    </div>
  </main>
  <div v-if="showLayout">
    <basic-footer v-if="route.name !== 'NotFoundMag'" />
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

import BasicFooter from "@/components/general/ui/footer/BasicFooter";
import TopNavbar from "@/components/general/ui/navbar/TopNavbar";
import WegowButton from "@/components/general/forms/WegowButton";
import WNavigation from "@/components/general/ui/WNavigation";
import { metas } from "@/plugins/mixins/metas";

const route = useRoute();
const router = useRouter();
const { t } = useI18n();

const props = defineProps({
  showLayout: {
    type: Boolean,
    default: true
  }
});

onMounted(() => {
  metas.methods.setLanguage();
  metas.methods.setCanonical();
  // Establecer el estado de respuesta HTTP como 404
  const statusCode = 404;
  const statusText = "Not Found";
  history.replaceState({ statusCode, statusText }, "", window.location.href);

  // Agregar la etiqueta "noindex" al head del documento
  const metaTag = document.createElement("meta");
  metaTag.name = "robots";
  metaTag.content = "noindex";
  document.head.appendChild(metaTag);
});
onBeforeMount(() => {
  metas.methods.setMetasHtml(
    {
      title: t("general.metas.notFoundTitle"),
      description: t("general.metas.notFoundDescription")
    },
    route,
    router
  );
});
</script>
<style lang="scss" scoped>
@media screen and (max-width: 700px) {
  #id-container {
    padding: 14px !important;
  }
  .message-container {
    padding-left: 20px;
    padding-right: 20px;
  }
  #go-to-wegow-button {
    margin-top: 50px !important;
  }
}
.error-page-container {
  width: 100%;
  max-height: 100vh;
  background-image: url("@/assets/images/background-error-page.png");
  background-repeat: round;
  padding-top: 93px;
}
.error-page-container p {
  font-size: calc(16px + (40 - 16) * ((100vw - 300px) / (1600 - 300)));
}
.message-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  max-height: 100vh;
  max-width: 788px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 252px;
  text-align: center;
}
.message-container i {
  margin-bottom: 27px;
}
#go-to-wegow-button {
  margin-top: 165px;
}
.background-mag {
  background-color: $backgroundBlack;
  color: $white;
}
</style>
